import { render } from "./AdminPage.vue?vue&type=template&id=08e2dfe3&ts=true"
import script from "./AdminPage.vue?vue&type=script&lang=ts"
export * from "./AdminPage.vue?vue&type=script&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=08e2dfe3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__